// src/analysis/conteoPalmas/conteoPalmasValidation.jsx

export const validateConteoPalmasData = (datosAnalisis) => ({
    conteoPalmas: datosAnalisis.conteoPalmas?.valor && datosAnalisis.conteoPalmas?.valor !== 0,
});
